var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttentionCircle1 = function SvgAttentionCircle1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 10C229.4 10 10 229.4 10 500s219.4 490 490 490 490-219.4 490-490S770.6 10 500 10m0 910C268 920 80 732 80 500S268 80 500 80s420 188 420 420-188 420-420 420"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465 710h70v70h-70zM465 220h70v420h-70z"
  })));
};
export default SvgAttentionCircle1;